<template>
  <v-sheet color="transparent" class="c360-proposal-status">
    <h2 :title="proposal.name" class="c360-proposal-status--name mb-n2">
      {{ proposal.name }}
    </h2>
    <v-menu
      v-model="open"
      v-if="editable"
      right
      transition="scroll-y-transition"
      :nudge-bottom="18"
      :min-width="290"
      :close-on-content-click="false"
      content-class="c360-menu"
    >
      <template #activator="{ attrs, on }">
        <v-btn
          text
          :style="{ color }"
          class="c360-proposal-status--status text-uppercase"
          v-on="on"
          v-bind="attrs"
        >
          {{ status }}
        </v-btn>
      </template>
      <v-sheet>
        <div class="px-6 py-4">
          <h2 class="c360-proposal-status--title">Update Status</h2>
        </div>
        <v-divider />
        <v-sheet class="px-6 py-4">
          <c360-selectable-item
            v-for="(status, i) in statuses"
            :key="status.value"
            :selected="i === selected"
            icon="Check_Big"
            class="mb-2"
            @click="select(i)"
          >
            {{ status.name }}
          </c360-selectable-item>
        </v-sheet>
        <v-divider />
        <v-sheet class="d-flex px-6 py-4">
          <v-btn text class="c360-button--text" @click="onCancel">Cancel</v-btn>
          <v-spacer />
          <v-btn text class="c360-button--text c360-primary--text" @click="onSave">
            Save Status
          </v-btn>
        </v-sheet>
      </v-sheet>
    </v-menu>
    <v-btn v-else text :style="{ color }" class="c360-proposal-status--status text-uppercase">
      {{ status }}
    </v-btn>
  </v-sheet>
</template>

<script>
  import Vue from 'vue';
  import { C360SelectableItem } from '../../../components/SelectableItem';

  export default Vue.extend({
    name: 'C360ProposalStatus',

    components: {
      C360SelectableItem,
    },

    props: {
      /**
       * Name of proposal and status.
       * @type {{
       *   name: string;
       *   status: string;
       * }}
       */
      proposal: {
        type: Object,
        required: true,
      },

      /**
       * On click by status the status selector dialog will be shown.
       */
      editable: {
        type: Boolean,
        default: false,
      },

      /**
       * Next statuses.
       */
      statuses: {
        type: Array,
        default: () => [],
      },

      /**
       * Config made by `makeProposalStatusConfig` function.
       */
      config: {
        type: Object,
        required: true,
      },
    },

    data() {
      return {
        open: false,
        selected: null,
      };
    },

    computed: {
      color() {
        const isValidConfig = this.validateConfig();
        return isValidConfig ? this.config.statuses[this.proposal.status].color : 'black';
      },
      status() {
        const isValidConfig = this.validateConfig();
        return isValidConfig
          ? this.config.statuses[this.proposal.status].text
          : this.proposal.status;
      },
    },

    methods: {
      validateConfig() {
        if (!Object.keys(this.config.statuses).length) return false;
        if (!this.config.statuses[this.proposal.status]) return false;
        return true;
      },
      select(i) {
        this.selected = i;
      },
      onCancel() {
        this.open = false;
        this.selected = null;
      },
      onSave() {
        this.$emit('save-status', this.statuses[this.selected ?? 0]);
        this.open = false;
        this.selected = null;
      },
    },
  });
</script>

<style scoped>
  .c360-proposal-status {
    font-family: var(--c360-font);
  }

  .c360-proposal-status--name {
    font-size: 16px;
    font-weight: 600;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 170px;
  }

  .c360-proposal-status--status {
    font-size: 10px !important;
    font-weight: 600;
    padding: 8px 0 !important;
    height: 10px !important;
    font-family: var(--c360-font);
    letter-spacing: 1px;
  }

  .c360-proposal-status--title {
    font-size: 14px !important;
    font-family: var(--c360-font);
  }
</style>
